import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If the URL has a hash, try to scroll to that element after paint.
    if (hash) {
      const id = hash.replace(/^#/, "");
      // Try immediately, then retry a few times in case the target hasn't
      // mounted yet (e.g. during a route change + reveal animations).
      let tries = 0;
      const tryScroll = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        if (tries < 12) {
          tries += 1;
          setTimeout(tryScroll, 60);
        } else {
          window.scrollTo({ top: 0, behavior: "instant" });
        }
      };
      tryScroll();
      return;
    }

    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);

  return null;
}
